<template>
  <div class="item-image">
    <vs-dropdown v-if="!preview" vs-custom-content vs-trigger-click class='btn-delete'>
      <vs-button
        v-if="!preview"
        style="cursor: pointer;"
        radius
        color="danger"
        type="flat"
        icon-pack="feather"
        icon="icon-trash"
      ></vs-button>
      <vs-dropdown-menu class="dropdown-login">
        <div class="dropdownMenu">
          <div class="d-flex" style="justify-content:space-between">
            <h3 class="mb-3">Supprimer ?</h3>
          </div>
          <vs-button
            style="width:100% !important;"
            @click="remove()"
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-check"
            size="flat"
          ></vs-button>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>
    <div :style="'display:flex;width:100%;justify-content:' + item.flexPosition">
      <img :style="getSize" :src="item.location" :alt="item.alt" />
    </div>
    <div v-if="!preview">
      <vs-dropdown vs-custom-content vs-trigger-click class='btn-settings border-primary'>
        <vs-button
          v-if="!preview"
          style="cursor: pointer;"
          radius
          class="border-primary"
          color="primary"
          type="flat"
          icon-pack="feather"
          icon="icon-camera"
        ></vs-button>
        <vs-dropdown-menu class="dropdown-login">
          <div class="dropdownMenu">
            <div class="d-flex" style="justify-content:space-between">
              <h4 class="mb-3">Paramètres</h4>
              <vs-switch style="width:60px" v-model="switch1">
                <span slot="on">IMAGE</span>
                <span slot="off">URL</span>
              </vs-switch>
            </div>
            <vs-button
              v-if="switch1"
              style="cursor: pointer;"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-folder"
              class="éedit mb-4 mt-3"
              @click="togglePopupFiles(true)"
            >
              Gestion documentaire
            </vs-button>
            <vs-input
              label="Url"
              class="form-control edit mb-4"
              type="text"
              style="width:100%"
              v-model="item.location"
              @blur="saveLocation"
              v-if="!switch1"
            />
            <label>Largeur : </label>
            <vs-input-number
              label="Taille (%)"
              class="m-0 mb-4"
              v-model="item.width"
              value="0"
              max="100"
              step="5"
              @blur="saveWidth"
            />

            <label>Alt : </label>
            <vs-input
              class="form-control edit mb-4"
              type="text"
              style="width:100%"
              v-model="item.alt"
              @blur="saveAlt"
            />
            <label >Position : </label>
            <div style="width:100%;">
              <ul class="d-flex">
                <li>
                  <vs-radio
                    class="m-2"
                    v-model="flexPosition"
                    vs-value="flex-start"
                    >Gauche</vs-radio
                  >
                </li>
                <li>
                  <vs-radio class="m-2" v-model="flexPosition" vs-value="center"
                    >Centre</vs-radio
                  >
                </li>
                <li>
                  <vs-radio class="m-2" v-model="flexPosition" vs-value="flex-end"
                    >Droite</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <!-- <PopupFiles
      @imageSrc="imageSrc"
      @closePopupFiles="togglePopupFiles"
      :activePopupFiles="activePopupFiles"
    ></PopupFiles> -->
  </div>
</template>

<script>
import vSelect from "vue-select";
// import PopupFiles from "@/layouts/components/popup/PopupFiles";

export default {
  props: [
    "preview",
    "contenteditable",
    "colIndex",
    "rowIndex",
    "layout",
    "index",
    "item",
  ],
  data() {
    return {
      switch1: true,
      activePopupFiles: false,
      flexPosition: "center",
    };
  },
  computed: {
    getSize() {
      return " width:" + this.item.width + "%;";
    },
  },
  watch:{
    flexPosition: function (newVal, oldVal) {
      this.item.flexPosition=newVal
      this.flexPosition=newVal
    }
  },    
  created(){
    if(!this.item.flexPosition){
      this.item.flexPosition="center"
    }
  },
  methods: {
    imageSrc(data) {
      this.item.location = data;
      this.item.height = 110;
    },
    remove() {
      this.layout[this.rowIndex].col[this.colIndex].content.splice(
        this.index,
        1
      );
    },
    saveLocation(e) {
      this.item.location = e.target.value;
    },
    saveAlt(e) {
      this.item.alt = e.target.value;
    },
    saveWidth(e) {
      if (e.target.value > 100) {
        this.item.width = 100;
      }
      this.item.width = e.target.value;
    },
    togglePopupFiles(val = false) {
      this.activePopupFiles = val;
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>

<style scoped>
.preview {
  position: absolute;
  left: 4px;
}

.edit {
  float: right;
  width: 90%;
}

.dropdownMenu {
  padding: 10px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
}
</style>
